import * as React from 'react';
import { getOmjsProjectInstance } from 'selectors';
import { getContainerIcon } from 'utils';

interface ISearchItem extends omjs.IContainer {
    parentName?: string
}


export interface ILayerResultItemProps {
    item: ISearchItem;
    onClick: (item: ISearchItem) => void;
}
export interface ILayerResultItemState {}

class LayerResultItemComponent extends React.Component<ILayerResultItemProps, ILayerResultItemState> {
    private project = getOmjsProjectInstance(false);

    constructor(props: ILayerResultItemProps) {
        super(props);

        this.onClick = this.onClick.bind(this);
    }

    onClick() {
        this.props.onClick(this.props.item);
    }

    render() {
        let { item } = this.props;
        return (
            <div className="layer-search-result" onClick={this.onClick}>
                <div className="layer-icon">
                    <img src={getContainerIcon(item)} />
                </div>
                <div className="layer-name">
                    <span>{item.name}</span>
                    <span>{item.parentName}</span>
                </div>
            </div>
        );
    }
}

export const LayerResultItem = LayerResultItemComponent;
